import { RemoteParamKeys } from '@/lib/firebase/config'
import { type BasePageProps } from '@/pages/_app'

export const WHITELIST_API_TOGGLE_KEY = 'KJCA-6569'

/**
 * Determines whether to apply the whitelist API feature based on Firebase remote config.
 * This utility is used to enable/disable the whitelist API globally.
 *
 * @param basePageProps - The base page props containing Firebase configuration and toggles
 * @returns An object containing the KJCA-6569 feature flag.
 *          Returns { 'KJCA-6569': 1 } when enabled, { 'KJCA-6569': -1 } when disabled.
 */
export const getWhitelistApiToggle = (basePageProps: BasePageProps) => {
  const whitelistApiEnabled =
    basePageProps?.firebaseConfig?.toggles?.[RemoteParamKeys?.WHITELIST_API]?.enabled ?? false

  return {
    [WHITELIST_API_TOGGLE_KEY]: whitelistApiEnabled ? 1 : -1,
  }
}
